import {
  GET_DASHBOARD_DATA,
  GET_DASHBOARD_DATA_SUCCESS,
  GET_DASHBOARD_DATA_ERROR,
  RESET_DASHBOARD_ERROR,
  LEADS_GET_DASHBOARD_DATA,
  LEADS_GET_DASHBOARD_DATA_ERROR,
  CALLS_GET_DASHBOARD_DATA,
  CALLS_GET_DASHBOARD_DATA_SUCCESS,
  CALLS_GET_DASHBOARD_DATA_ERROR,
  LEADS_GET_DASHBOARD_DATA_SUCCESS,
  CLICK_INSURANCE_TYPE_METRICS,
  CLICK_INSURANCE_TYPE_METRICS_SUCCESS,
  CLICK_INSURANCE_TYPE_METRICS_ERROR,
  CALL_INSURANCE_TYPE_METRICS,
  CALL_INSURANCE_TYPE_METRICS_SUCCESS,
  CALL_INSURANCE_TYPE_METRICS_ERROR,
  LEAD_INSURANCE_TYPE_METRICS,
  LEAD_INSURANCE_TYPE_METRICS_SUCCESS,
  LEAD_INSURANCE_TYPE_METRICS_ERROR,

} from './actionTypes';

export const getDashboardData = (dashboard_query_params, api_type, v3_api, v3_conversions_api) => ({
  type: GET_DASHBOARD_DATA,
  payload: dashboard_query_params,
  api_type: api_type,
  v3_api: v3_api,
  v3_conversions_api: v3_conversions_api
});

export const getDashboardDataSuccess = (dashboard_data, api_type) => ({
  type: GET_DASHBOARD_DATA_SUCCESS,
  payload: dashboard_data,
  api_type: api_type
});

export const getDashboardDataError = (error, api_type) => ({
  type: GET_DASHBOARD_DATA_ERROR,
  payload: error,
  api_type: api_type
});

//For Leads
export const getLeadsDashboardData = (dashboard_query_params, api_type) => ({
  type: LEADS_GET_DASHBOARD_DATA,
  payload: dashboard_query_params,
  api_type: api_type
});

export const getLeadsDashboardDataSuccess = (dashboard_data, api_type) => ({
  type: LEADS_GET_DASHBOARD_DATA_SUCCESS,
  payload: dashboard_data,
  api_type: api_type
});

export const getLeadsDashboardDataError = (error, api_type) => ({
  type: LEADS_GET_DASHBOARD_DATA_ERROR,
  payload: error,
  api_type: api_type
});

//For Calls
export const getCallsDashboardData = (dashboard_query_params, api_type) => ({
  type: CALLS_GET_DASHBOARD_DATA,
  payload: dashboard_query_params,
  api_type: api_type
});

export const getCallsDashboardDataSuccess = (dashboard_data, api_type) => ({
  type: CALLS_GET_DASHBOARD_DATA_SUCCESS,
  payload: dashboard_data,
  api_type: api_type
});

export const getCallsDashboardDataError = (error, api_type) => ({
  type: CALLS_GET_DASHBOARD_DATA_ERROR,
  payload: error,
  api_type: api_type
});

//For {CLICK} Insurance Type Metrics
export const getClickInsuranceTypeMetrics = (dashboard_query_params, api_type) => ({
  type: CLICK_INSURANCE_TYPE_METRICS,
  payload: dashboard_query_params,
  api_type: api_type
});

export const getClickInsuranceTypeMetricsSuccess = (dashboard_data, api_type) => ({
  type: CLICK_INSURANCE_TYPE_METRICS_SUCCESS,
  payload: dashboard_data,
  api_type: api_type
});

export const getClickInsuranceTypeMetricsError = (error, api_type) => ({
  type: CLICK_INSURANCE_TYPE_METRICS_ERROR,
  payload: error,
  api_type: api_type
});

//For {CLICK} Insurance Type Metrics
export const getLeadInsuranceTypeMetrics = (dashboard_query_params, api_type) => ({
  type: LEAD_INSURANCE_TYPE_METRICS,
  payload: dashboard_query_params,
  api_type: api_type
});

export const getLeadInsuranceTypeMetricsSuccess = (dashboard_data, api_type) => ({
  type: LEAD_INSURANCE_TYPE_METRICS_SUCCESS,
  payload: dashboard_data,
  api_type: api_type
});

export const getLeadInsuranceTypeMetricsError = (error, api_type) => ({
  type: LEAD_INSURANCE_TYPE_METRICS_ERROR,
  payload: error,
  api_type: api_type
});

//For {CLICK} Insurance Type Metrics
export const getCallInsuranceTypeMetrics = (dashboard_query_params, api_type) => ({
  type: CALL_INSURANCE_TYPE_METRICS,
  payload: dashboard_query_params,
  api_type: api_type
});

export const getCallInsuranceTypeMetricsSuccess = (dashboard_data, api_type) => ({
  type: CALL_INSURANCE_TYPE_METRICS_SUCCESS,
  payload: dashboard_data,
  api_type: api_type
});

export const getCallInsuranceTypeMetricsError = (error, api_type) => ({
  type: CALL_INSURANCE_TYPE_METRICS_ERROR,
  payload: error,
  api_type: api_type
});

export const resetDashboardError = () => ({
  type: RESET_DASHBOARD_ERROR,
});
